module.exports = __webpack_public_path__ + "img/2-noparticipated.36cac2d2.png";